export class PersonModel {
  isChecked: boolean;
  driverMasterHashId(arg0: any): any {
    throw new Error('Method not implemented.');
  }
  driverName(arg0: any): any {
    throw new Error('Method not implemented.');
  }
  public personMasterHashId: string;
  public userName: string;
  public firstName: string;
  public middleName: string;
  public lastName: string;
  public countryCode1: string = '';
  public countryCode2: string = '';
  public telephone1: string;
  public telephone2: string;
  public isActive: boolean;
  public personHomeAddressModel: PersonAddressModel;
  public personWorkAddressModel: PersonAddressModel;
  public emailAddressModel: EmailAddressModel;
  public instanceId: string;
  public instanceHashId: string = '';
  public personRole: string[] = [];
  public instanceName: string;
  public contactPerson: string[] = [];
  public dateOfBirth: string;
  public password: string;
  public isWeGoAdmin: boolean;
  public directDebitFileEnabledOnInstance: boolean = false;
  public subjectToDirectDebit: boolean;
  public organizationHashId: string;
  public mandateId: number;
  public mandateSignatureDate: string;
  public isAmmandment: boolean = false;
  public isDeletable: boolean;
  public isEditable: boolean;
  public removalDateTime: Date;
  public enableLogin: boolean = true;
  public enableErrorEscalation: boolean = true;
  public errorEscalationMinutes: string;
  public nifNumber: string;
  public isnifEnabled: boolean = false;
  public inActiveReason: string;
  public isInstanceTwofaEnabled: boolean = false;
  public countryCodeHashId:string;
  public rfidTagId: string;
  public employeeNumber: string; 
  public licenseTypes: string = "";
  public certificates: string;
  public accessCardId: string;
  public ibanNumber: string;
  public bicCode: string;
  public preferredlanguage: string;
  public debtornr: string;

  constructor() {
    this.personHomeAddressModel = new PersonAddressModel();
    this.personWorkAddressModel = new PersonAddressModel();
    this.emailAddressModel = new EmailAddressModel();
  }
}

export class EmailAddressModel {
  public email: string;
}

export class PersonAddressModel {
  public houseNo: string;
  public houseExtention: string;
  public street: string;
  public city: string;
  public zipCode: string;
  public address: string;
  public latitiude: number;
  public logitude: number;
}

export class PersonDeleteModel {
  public personMasterHashId: string;
  public isDelete: boolean;
}

export class PersonRemoveModel {
  public personMasterHashId: string;
  public removalDateTime: Date;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/person/models/person.model.ts